import type {
    RealestateProjectResultEntry,
    RealestateResultEntry,
} from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import type { BaseSearchAdProps } from '../search/SearchAdTypes';
import { type AdOfTheWeekFooterProps } from '../search/realestate/AdOfTheWeekFooter';
import { AdOfTheWeekSearchAd } from '../search/realestate/AdOfTheWeekSearchAd';
import { LegendaryAdImageOptions } from './LegendaryAdImageOptions';

type LegendaryAdOfTheWeekSearchAdProps = BaseSearchAdProps & {
    ad: RealestateResultEntry | RealestateProjectResultEntry;
    footer: AdOfTheWeekFooterProps;
    imageSizes?: string;
};

export function LegendaryAdOfTheWeekSearchAd(
    props: LegendaryAdOfTheWeekSearchAdProps,
) {
    const { className = '' } = props;

    return (
        <LegendaryAdImageOptions>
            <AdOfTheWeekSearchAd
                {...props}
                className={`${className} hover:s-bg-subtle`}
            />
        </LegendaryAdImageOptions>
    );
}
